import { DataBean } from "../DataBean";

export class CostConstants extends DataBean {


    public async getProductionOrderCostConstants(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProductionOrderCostConstants_Number", [id]);
    }

}